// extracted by mini-css-extract-plugin
module.exports = {"menu__btn":"MenuBtn_menu__btn__jmjQL","menu__returnBtn":"MenuBtn_menu__returnBtn__23NQn","menu__specialBtn":"MenuBtn_menu__specialBtn__3t2Yb"};